import { useEffect } from "react";
import { Route, Routes, Navigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import './App.css';


import SmoothScroll from "./Components/SmoothScroll";

import AlumnusNetwork from "./Components/Alumnus_Network.jsx";
import About from "./Components/About_Section";
import Team from "./Components/Team.jsx";
import CollegeActivitiesMain from "./Components/Activities_Section";
import CampusAmbassador from "./Components/Campus_Ambassador.jsx";
import Chapters from "./Components/Chapters.jsx";
import Camps from "./Components/Camps.jsx";
import Courses from "./Components/Courses.jsx";
import Dashboard from "./Components/Dashboard.jsx";
import EthiccraftCollege from './Components/Colleges_Ethiccraft/EthiccraftCollege.jsx';
import Home from "./Components/Home_Page";
import LoginApp from "./Components/Login_App.jsx";
import ObjectivesApp from "./Components/Objectives/Objectives_App.jsx";
import ProfileEdit from "./Components/Profile/Profile_Edit";
import ProfileCard from "./Components/Profile/Profile_Card";
import RegistrationApp from "./Components/Registration_App";
import Resident from "./Components/Residential-Facilities.jsx";
import ValuesApp from "./Components/Values_App.jsx";

function App() {
  
  useEffect(() => {
    // Initialize AOS
    AOS.init({ 
      duration: 1000,
      once: true, // Animation happens only once - better performance
      mirror: false 
    });
  }, []);
  
  return (
    <SmoothScroll>
      <div>
        <Routes>        
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/activities" element={<CollegeActivitiesMain  />} />
          <Route path="/chapters" element={<Chapters/>} />
          <Route path="/courses" element={<Courses/>} /> 
          <Route path="/:collegeCode" element={<EthiccraftCollege />} />
          <Route path="/camps" element={<Camps />} />
          <Route path="/valumni" element={<AlumnusNetwork/>} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/profileEdit" element={<ProfileEdit />} />
          <Route path="/register" element={<RegistrationApp />} />
          <Route path="/profile" element={<ProfileCard />} />
          <Route path="/values/*" element={<ValuesApp />} />
          <Route path="/objectives" element={<ObjectivesApp />} />
          <Route path="/login" element={<LoginApp/>} />
          <Route path="/campus-ambassador" element={<CampusAmbassador />} />
          <Route path="/residential-facilities" element={<Resident />} />
          {/* Fixed the Navigate usage */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </SmoothScroll>
  );
}

export default App;